import { Injectable } from "@angular/core";

type LogArgs = (string | number | boolean)[];

@Injectable({
    providedIn: "root",
})
export class LoggerService {
    log(msg: string, ...args: LogArgs) {
        console.log(msg, ...this.sanitizeArgs(...args));
    }

    warn(msg: string, ...args: LogArgs) {
        console.warn(msg, ...this.sanitizeArgs(...args));
    }

    error(msg: string, ...args: LogArgs) {
        console.error(msg, ...this.sanitizeArgs(...args));
    }

    private sanitizeArgs(...args: LogArgs) {
        return args
            .map((arg) => arg?.toString().replace("\n", "_").replace("\r", "_"))
            .map((arg) => encodeURIComponent(arg));
    }
}
